import { api } from '../configs/axiosConfigs';

export const deleteSavedSearchCriteria = async (criteriaId: string) => {
  return await api.delete(`/property_search_criteria/${criteriaId}`);
};
